// components/CurrentVacancies/CurrentVacancies.tsx
import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { useDispatch } from "react-redux";
import VacancyCard from "./VacancyCard";
import { Vacancy } from "./config/vacancyConfig";
import { getData } from "../../../../../../actions/apiCall";

interface DepartmentOption {
  label: string;
  value: string;
}

// Employment type → color mapping
const COLOR_MAP: Record<string, string> = {
  "Part Time": "bg-green-100 text-green-600",
  "Full Time": "bg-purple-100 text-purple-600",
};

interface DepartmentOption {
  label: string;
  value: string;
}

const CurrentVacancies: React.FC = () => {
  const dispatch = useDispatch();
  const [vacancies, setVacancies] = useState<Vacancy[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [departments, setDepartments] = useState<DepartmentOption[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState<string>("all");

  useEffect(() => {
    fetchVacancies();
    fetchDepartments();
  }, []);

  const fetchVacancies = async () => {
    setLoading(true);

    try {
      const response: any = await dispatch(
        getData("/analytic/deshboard/openings/dashboard")
      );

      console.log("Vacancy API response 👉", response);

      // ✅ ACCESS THE ARRAY CORRECTLY
      const apiList = response?.data || [];

      if (Array.isArray(apiList)) {
        const mappedVacancies: Vacancy[] = apiList.map((item: any) => ({
          title: item.employmentType || "Unknown Role",

          ctc: `${item.ctc?.minimum ?? 0} - ${item.ctc?.maximum ?? 0
            } ${item.ctc?.currency ?? ""}`,

          mode: [
            item.jobLocationType,
            item.employmentType,
          ].filter(Boolean),

          openings: item.openings ?? 0,
          applications: item.applications ?? 0,

          color:
            COLOR_MAP[item.employmentType] ||
            "bg-gray-100 text-gray-600",
        }));

        setVacancies(mappedVacancies);
      } else {
        setVacancies([]);
      }
    } catch (error) {
      console.error("Error fetching vacancies:", error);
      setVacancies([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartments = async () => {
    const res: any = await dispatch(getData("/departments"));

    console.log("Departments API Response:", res);

    // ✅ CORRECT based on your API
    const departmentList = res?.data;

    if (Array.isArray(departmentList)) {
      const options: DepartmentOption[] = [
        { label: "All Departments", value: "all" },
        ...departmentList.map((dept: any) => ({
          label: dept.name,
          value: dept._id,
        })),
      ];

      setDepartments(options);
    } else {
      console.error("Departments is not an array", departmentList);
    }
  };


  return (
    <div className="bg-white shadow rounded-lg p-4 mt-4 mx-2 w-full">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">Current Vacancies</h2>
        <Select
          className="w-48"
          value={selectedDepartment}
          options={departments}
          onChange={(value) => setSelectedDepartment(value)}
          placeholder="Select Department"
        />
      </div>

      {loading ? (
        <p className="text-sm text-gray-500">Loading vacancies...</p>
      ) : (
        <div className="flex gap-4 overflow-x-auto pb-2 scrollbar-hide">
          {vacancies.length > 0 ? (
            vacancies.map((vacancy, index) => (
              <VacancyCard key={index} vacancy={vacancy} />
            ))
          ) : (
            <p className="text-sm text-gray-400">
              No vacancies available
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default CurrentVacancies;
